import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import { AttachmentType } from '../../../types/transaction';
import { ATTACHMENT_TYPES } from '../../../constants/attachments';

interface AttachmentTypeSelectProps {
  value: AttachmentType;
  onChange: (value: AttachmentType) => void;
  disabled?: boolean;
}

export function AttachmentTypeSelect({ value, onChange, disabled }: AttachmentTypeSelectProps) {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Selecione o tipo" />
      </SelectTrigger>
      <SelectContent>
        {ATTACHMENT_TYPES.map((type) => (
          <SelectItem key={type.value} value={type.value}>
            {type.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
